import type { SxProps } from "@mui/material"

import {
  CHECKBOX_BORDER_COLOR,
  DELETE_COLOR,
  GRAY_COLOR,
  NOTIFICATION_ICONS_ACTIVE,
  NOTIFICATION_ICONS_OFF,
  PRIMARY
} from "@constants/colors"

const notificationsActiveIcon: SxProps = {
  cursor: "pointer",
  color: NOTIFICATION_ICONS_ACTIVE,
  height: "1.1rem"
}

const menuListItemActive: SxProps = {
  color: NOTIFICATION_ICONS_ACTIVE
}

const menuListItemOff: SxProps = {
  color: NOTIFICATION_ICONS_OFF
}

const grayColor: SxProps = {
  color: GRAY_COLOR
}
const deleteColor: SxProps = {
  color: DELETE_COLOR
}

const rightBox: SxProps = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 2
}

const toolbarContainer: SxProps = {
  flexDirection: "row",
  gap: 1,
  p: 0,
  pt: "0.5rem"
}

const searchInput = {
  outline: "none",
  border: "none",
  width: "100%"
}
const optionContainer: SxProps = {
  display: "flex",
  alignItems: "center",
  color: GRAY_COLOR,
  border: `1px solid ${CHECKBOX_BORDER_COLOR}`,
  padding: "0.2rem",
  borderRadius: "0.5rem"
}

const optionContainerActive: SxProps = {
  display: "flex",
  alignItems: "center",
  color: PRIMARY,
  border: `1px solid ${CHECKBOX_BORDER_COLOR}`,
  padding: "0.2rem",
  borderRadius: "0.5rem"
}

const actionBox: SxProps = {
  position: "relative",
  border: `1px solid ${CHECKBOX_BORDER_COLOR}`,
  minWidth: 125,
  zIndex: 1,
  borderRadius: "0.5rem",
  height: "2.3rem",
  paddingTop: "0.3rem",
  overflow: "hidden"
}

export default {
  notificationsActiveIcon,
  menuListItemActive,
  menuListItemOff,
  grayColor,
  searchInput,
  deleteColor,
  rightBox,
  optionContainerActive,
  optionContainer,
  toolbarContainer,
  actionBox
}
